import _styled, { default as _styled2, default as _styled3 } from "styled-components";
import "core-js/modules/web.dom-collections.iterator.js";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import styled, { useTheme } from "styled-components";
import Box from "../Styled/Box";
import Button from "../Styled/Button";
import Icon, { StyledIcon } from "../Styled/Icon";
import Input from "../Styled/Input";
import Spacing from "../Styled/Spacing";
import { TextSpan } from "../Styled/Text";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var CopyStatus = /*#__PURE__*/function (CopyStatus) {
  CopyStatus[CopyStatus["Success"] = 0] = "Success";
  CopyStatus[CopyStatus["Error"] = 1] = "Error";
  CopyStatus[CopyStatus["Default"] = 2] = "Default";
  return CopyStatus;
}(CopyStatus || {});
const Clipboard = props => {
  const {
    text,
    inputTheme,
    inputPlaceholder,
    onCopy,
    createdMessage
  } = props;
  const {
    t
  } = useTranslation();
  const styledTheme = useTheme();
  const [status, setStatus] = useState(CopyStatus.Default);
  const [showCreatedMessage, setShowCreatedMessage] = useState(false);
  const prevTextRef = useRef(text);
  useEffect(() => {
    if (createdMessage && !prevTextRef.current && text) {
      setShowCreatedMessage(true);
    }
    prevTextRef.current = text;
  }, [text, createdMessage]);
  const handleCopy = async () => {
    setShowCreatedMessage(false);
    try {
      if (text) {
        await navigator.clipboard.writeText(text);
        setStatus(CopyStatus.Success);
        if (onCopy) onCopy(text);
      } else {
        setStatus(CopyStatus.Error);
      }
    } catch (_unused) {
      setStatus(CopyStatus.Error);
    }
  };
  useEffect(() => {
    if (status === CopyStatus.Success || status === CopyStatus.Error) {
      var _props$timeout;
      const timer = setTimeout(() => {
        setStatus(CopyStatus.Default);
      }, (_props$timeout = props.timeout) !== null && _props$timeout !== void 0 ? _props$timeout : 3000);
      return () => clearTimeout(timer);
    }
  }, [status, props.timeout]);
  const canCopy = !!navigator.clipboard;
  const statusMessage = status === CopyStatus.Error ? t("clipboard.unsuccessful") : status === CopyStatus.Success ? t("clipboard.success") : createdMessage;
  return /*#__PURE__*/_jsxs(ClipboardDiv, {
    children: [/*#__PURE__*/_jsxs(Box, {
      children: [/*#__PURE__*/_jsx(Input, {
        light: inputTheme === "light",
        dark: inputTheme === "dark",
        large: true,
        type: "text",
        value: text,
        placeholder: inputPlaceholder !== null && inputPlaceholder !== void 0 ? inputPlaceholder : t("share.shortLinkShortening"),
        readOnly: true,
        onClick: e => e.currentTarget.select()
      }), canCopy && /*#__PURE__*/_jsx(_StyledButton, {
        onClick: handleCopy,
        primary: true,
        textProps: {
          large: true
        },
        children: t("clipboard.copy")
      })]
    }), canCopy && status !== CopyStatus.Default || showCreatedMessage ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Spacing, {
        bottom: 1
      }), /*#__PURE__*/_jsxs(Box, {
        verticalCenter: true,
        children: [/*#__PURE__*/_jsx(_StyledStyledIcon, {
          light: true,
          glyph: status === CopyStatus.Error ? Icon.GLYPHS.close : Icon.GLYPHS.selected,
          styledWidth: "16px",
          $_css: status !== CopyStatus.Error && "fill: ".concat(styledTheme.textSuccess, ";")
        }), /*#__PURE__*/_jsx(_StyledTextSpan, {
          medium: true,
          $_css2: status !== CopyStatus.Error && "color: ".concat(styledTheme.textSuccess, ";"),
          children: statusMessage
        })]
      })]
    }) : null]
  });
};
export default Clipboard;
const ClipboardDiv = styled.div.withConfig({
  displayName: "Clipboard__ClipboardDiv",
  componentId: "sc-suy455-0"
})(["position:relative;"]);
var _StyledButton = styled(Button).withConfig({
  displayName: "Clipboard___StyledButton",
  componentId: "sc-suy455-1"
})(["width:80px;border-radius:0 2px 2px 0;"]);
var _StyledStyledIcon = styled(StyledIcon).withConfig({
  displayName: "Clipboard___StyledStyledIcon",
  componentId: "sc-suy455-2"
})(["margin:5px;margin-left:0;display:inline-block;", ""], p => p.$_css);
var _StyledTextSpan = styled(TextSpan).withConfig({
  displayName: "Clipboard___StyledTextSpan",
  componentId: "sc-suy455-3"
})(["", ""], p => p.$_css2);